<template>
	<div>
		<div style="font-size: 20px; text-align: center;width: 100%; color:#42C052;padding: 10px 0;">离我最近的自提点</div>		
		<van-row v-if="branchs" v-for="(item,index) in branchs" :key="index" type="flex" style="text-align: left; padding: 10px;border-bottom: 1px solid #ccc;" @click="goOrderSubmit(item)">
		  <van-col span="17">
				<span class="van-ellipsis" style="font-weight: 700;">{{item.name}}</span>
			  </van-col>
		  <van-col  style="color:#42C052;flex: 1;text-align: right;">{{item.distance}} ></van-col>
		  <van-col span="24" class="van-ellipsis" style="color:#444;">地址:{{item.addr}}</van-col>
		</van-row>
		<div v-else>抱歉，附近无可用的自提点</div>
	</div>
</template>

<script>
	import { mapState,mapMutations} from 'vuex'
	export default {
		name:"selfLiftingPoint",
		methods:{
			...mapMutations(['setDiscount']),
			onClickLeft(){
				this.$router.go(-1)
			},
			//选择自提点
			goOrderSubmit(branch){
				this.setDiscount(1)
				this.$router.replace({ 
					path: 'orderSubmit', 
					query: { branch: JSON.stringify(branch) },
				})
			},
		},
		computed:{
			...mapState(['branchs']),
			branchs(){
				
			return	[
				  {
				    "id": 70,
				    "name": "西大营食迅惠民自提点",
				    "addr": "西大营",
				    "longitude": "116.261464",
				    "latitude": "39.765185",
				    "distance": "9m"
				  },
				  {
				    "id": 9,
				    "name": "复兴路第三供应点-复兴路22",
				    "addr": "海淀区复兴路22号院",
				    "longitude": "116.291137",
				    "latitude": "39.901784",
				    "distance": "15.4km"
				  },
				  {
				    "id": 8,
				    "name": "复兴路第二供应点-复兴路26",
				    "addr": "海淀区复兴路26号院",
				    "longitude": "116.281064",
				    "latitude": "39.903568",
				    "distance": "15.48km"
				  },
				  {
				    "id": 10,
				    "name": "复兴路第四供应点-复兴路20",
				    "addr": "海淀区复兴路20号院",
				    "longitude": "116.300044",
				    "latitude": "39.904435",
				    "distance": "15.83km"
				  },
				  {
				    "id": 16,
				    "name": "供应站-万寿路分店",
				    "addr": "海淀区万寿路4号院",
				    "longitude": "116.283678",
				    "latitude": "39.91468",
				    "distance": "16.73km"
				  },
				  {
				    "id": 14,
				    "name": "供应站-金沟河分店",
				    "addr": "海淀区金沟河东路5号院1号楼西侧",
				    "longitude": "116.280128",
				    "latitude": "39.917921",
				    "distance": "17.06km"
				  },
				  {
				    "id": 52,
				    "name": "海淀区56所",
				    "addr": "海淀区万寿路甲5号院",
				    "longitude": "116.29517",
				    "latitude": "39.921751",
				    "distance": "17.65km"
				  },
				  {
				    "id": 71,
				    "name": "海淀离52所（晾果厂丙25号院）",
				    "addr": "海淀区玉渊潭公寓（玉渊潭公园南）晾果厂丙25号院",
				    "longitude": "116.280049",
				    "latitude": "39.924054",
				    "distance": "17.74km"
				  },
				  {
				    "id": 50,
				    "name": "五棵松北8号院自提点-53所",
				    "addr": "海淀区五棵松北8号院",
				    "longitude": "116.283108",
				    "latitude": "39.92525",
				    "distance": "17.89km"
				  },
				  {
				    "id": 46,
				    "name": "定慧北里分店-49所",
				    "addr": "海淀区定慧北里2号院",
				    "longitude": "116.283977",
				    "latitude": "39.925754",
				    "distance": "17.96km"
				  },
				  {
				    "id": 49,
				    "name": "海淀离52所（10号院）",
				    "addr": "海淀区阜成路友谊里10号院",
				    "longitude": "116.328594",
				    "latitude": "39.921438",
				    "distance": "18.3km"
				  },
				  {
				    "id": 44,
				    "name": "47所",
				    "addr": "海淀区玲珑路八里庄北里1号院",
				    "longitude": "116.298706",
				    "latitude": "39.937005",
				    "distance": "19.37km"
				  },
				  {
				    "id": 45,
				    "name": "海淀区48离",
				    "addr": "海淀区车公庄西路12号院",
				    "longitude": "116.333918",
				    "latitude": "39.93705",
				    "distance": "20.09km"
				  },
				  {
				    "id": 57,
				    "name": "西二退",
				    "addr": "西城区西四东大街43号院",
				    "longitude": "116.381833",
				    "latitude": "39.93036",
				    "distance": "21.05km"
				  },
				  {
				    "id": 5,
				    "name": "旃坛寺第二供应点-1号院",
				    "addr": "西城区爱民街1号院",
				    "longitude": "116.38875",
				    "latitude": "39.935242",
				    "distance": "21.81km"
				  },
				  {
				    "id": 6,
				    "name": "旃坛寺第三供应点-爱民街",
				    "addr": "西城区爱民街2号院",
				    "longitude": "116.389918",
				    "latitude": "39.938489",
				    "distance": "22.17km"
				  },
				  {
				    "id": 7,
				    "name": "旃坛寺第五供应点-新外大街23",
				    "addr": "海淀区新外大街新街口外大街23号院",
				    "longitude": "116.370372",
				    "latitude": "39.956283",
				    "distance": "23.2km"
				  },
				  {
				    "id": 38,
				    "name": "海淀区第41离职干部休养所",
				    "addr": "海淀区蓝靛厂路13号",
				    "longitude": "116.293541",
				    "latitude": "39.974489",
				    "distance": "23.43km"
				  },
				  {
				    "id": 15,
				    "name": "供应站-新康街分店",
				    "addr": "西城区新康街1号院东侧",
				    "longitude": "116.374902",
				    "latitude": "39.958306",
				    "distance": "23.56km"
				  },
				  {
				    "id": 11,
				    "name": "黄寺第二供应点-黄寺27",
				    "addr": "西城区黄寺27号院",
				    "longitude": "116.381077",
				    "latitude": "39.9631",
				    "distance": "24.26km"
				  },
				  {
				    "id": 13,
				    "name": "黄寺第四供应点-安德里",
				    "addr": "东城区安德里北街21号院东院",
				    "longitude": "116.397205",
				    "latitude": "39.957316",
				    "distance": "24.31km"
				  },
				  {
				    "id": 12,
				    "name": "黄寺第三供应点-黄寺乙1",
				    "addr": "东城区黄寺乙1号院",
				    "longitude": "116.39415",
				    "latitude": "39.962644",
				    "distance": "24.71km"
				  },
				  {
				    "id": 36,
				    "name": "苏州街港沟15号院自提点（39所）",
				    "addr": "海淀区苏州街港沟路15号院",
				    "longitude": "116.309431",
				    "latitude": "39.987695",
				    "distance": "25.08km"
				  },
				  {
				    "id": 2,
				    "name": "西山第一供应点-厢红旗",
				    "addr": "海淀区遗光寺路厢红旗030大院",
				    "longitude": "116.252023",
				    "latitude": "40.012737",
				    "distance": "27.54km"
				  }
				]
			}
		},
		mounted() {
			
			
		},
		created() {
			this.$wxLocation()
		}
	}
</script>

<style>
</style>
